<template>
  <div id="main-box" style="overflow:auto;">
    <div id="content-box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="销售商品" name="first">
          销售商品
        </el-tab-pane>
        <el-tab-pane label="操作日志" name="second">
          <el-card>
            <div>
              <el-form :inline="true">
                <el-form-item label="操作时间:">
                  <el-radio-group v-model="queryForm.optionTime">
                    <el-radio :label="1">今天</el-radio>
                    <el-radio :label="2">近7天</el-radio>
                    <el-radio :label="3">近30天</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="操作人:">
                  <el-input size="small" v-model="queryForm.operator" placeholder="请输入内容"></el-input>
                </el-form-item>

                <el-form-item label="选择时间">
                  <el-col :span="11">
                    <el-form-item prop="date1">
                      <el-date-picker type="date" size="small" placeholder="年/月/日" v-model="queryForm.startDate" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="1">~</el-col>
                  <el-col :span="11">
                    <el-form-item prop="date2">
                      <el-date-picker type="date" size="small" placeholder="年/月/日" v-model="queryForm.endDate" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" size="small" @click="search">筛选</el-button>
                  <el-button size="small" @click="empty">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding-bottom: 15px;">
              <toolbar
                  :buttonList="buttonList_toolBar"
                  @callFunction="callFunction"
              ></toolbar>
            </div>
            <el-table
              id="user-table"
              :data="userList"
              highlight-current-row
              v-loading="tableLoading"
              @selection-change="handleSelectionChange"
              style="width: 100%"
              border
            >
              <el-table-column
                type="index"
                label="序号"
                width="50"
                align="center">
              </el-table-column>
              <el-table-column
                prop="sort"
                label="操作时间"
                min-width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="spuId"
                label="操作人"
                min-width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="skuId"
                label="操作内容"
                min-width="180"
                align="center"
              ></el-table-column>
            </el-table>
            <el-pagination
              layout="total, sizes, prev, pager, next, jumper"
              style="float: right"
              :total="total"
              :current-page="queryForm.pageIndex"
              :pageSize="queryForm.pageSize"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            ></el-pagination>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </div>


    <el-dialog
      title="添加商品"
      :visible.sync="addProductDialog"
      v-if="addProductDialog"
      v-model="addProductDialog"
      :close-on-click-modal="false"
      width="80%"
    >
      <el-form :inline="true" ref="addProductForm" :model="addProductForm">
        <el-form-item label="选择分销商">
          <el-select size="small" v-model="addProductForm.distributor">
            <el-option :value="null" label="全部"></el-option>
            <el-option :value="true" label="正常"></el-option>
            <el-option :value="false" label="禁用"></el-option>
          </el-select>
        </el-form-item>
        <div style="background-color: #F3F3F3;padding: 20px 20px 0 20px;border-radius: 6px;margin-bottom: 20px;">
          <el-form-item label="商品spuid:">
            <el-input
              v-model="addProductForm.SpuId"
              placeholder="请输入商品Id"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品名称:">
            <el-input
              v-model="addProductForm.ProName"
              placeholder="请输入商品名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品型号:">
            <el-input
              v-model="addProductForm.ProCode"
              placeholder="请输入型号"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品类型">
            <el-cascader
              v-model="addProductForm.ProTypeId"
              :props="{ value: 'Id', label: 'TypeName', children: 'Childrens' }"
              :show-all-levels="false"
              :options="productNavTypeTreeList"
              placeholder="请选择类型"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="商品品牌">
            <el-select
              :disabled="brandId != null"
              v-model="addProductForm.ProBrandId"
              filterable
              allow-create
              default-first-option
              placeholder="请选择品牌"
            >
              <el-option
                v-for="(item, index) in brandList"
                :key="index"
                :label="item.value"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left: 40px">
            <el-button type="primary" @click="searchFun(1)">查询</el-button>
            <el-button type="danger" @click="resetFun">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
      <el-table
        :data="addProductList"
        @selection-change="handleSelectionChange"
        border
      >
        <el-table-column
          type="selection"
          width="50"
          fixed
          align="center"
        ></el-table-column>
        <el-table-column
          prop="SpuId"
          label="SpuId"
          min-width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="ProName"
          label="商品名称"
          align="center"
          min-width="350"
        ></el-table-column>
        <el-table-column
          prop="ProTypeName"
          label="商品类型"
          min-width="110"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="ProBrandName"
          label="商品品牌"
          min-width="110"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="ProCode"
          label="商品型号"
          min-width="110"
          align="center"
        ></el-table-column>
        <el-table-column 
          prop="CostPrice" 
          label="成本价" 
          min-width="110" 
          align="center">
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        style="float: right"
        :total="total"
        :current-page="addProductForm.pageIndex"
        :pageSize="addProductForm.pageSize"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="width:100%;">
        <el-button @click.native="addProductDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitAddPro" :loading="submitLoading">下一步</el-button>
      </div>
    </el-dialog>


    <el-dialog
      title="设置价格"
      :visible.sync="setPriceDialog"
      v-if="setPriceDialog"
      v-model="setPriceDialog"
      :close-on-click-modal="false"
      width="75%"
    >
      <el-table
        border
        :data="setPriceList"
        :header-cell-style="{background:'#F3F3F3'}"
        id="act-set-table"
        :span-method="objectSpanMethod"
      >
        <el-table-column
          prop="proName"
          min-width="120"
          align="center"
          label="商品名称">
        </el-table-column>
        <el-table-column
          prop="distributor"
          min-width="120"
          align="center"
          label="分销商">
        </el-table-column>
        <el-table-column
          prop="specName"
          min-width="120"
          align="center"
          label="规格名称">
        </el-table-column>
        <el-table-column
          prop="costPrice"
          min-width="120"
          align="center"
          label="成本价">
        </el-table-column>
        <el-table-column label="供货价" min-width="120" align="center" style="border: red solid 1px;">
          <template slot-scope="scope">
            <el-input v-model="scope.row.supplyPrice" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.status">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addProductDialog = false, setPriceDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitSetPrice">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="商品同步"
      :visible.sync="proSyncDialog"
      v-if="proSyncDialog"
      v-model="proSyncDialog"
      :close-on-click-modal="false"
      width="75%"
    >
      <el-table
        border
        :data="syncList"
        :header-cell-style="{background:'#F3F3F3'}"
        id="act-set-table"
      >
        <el-table-column
          prop="distributor"
          min-width="120"
          align="center"
          label="分销商名称">
        </el-table-column>
        <el-table-column
          prop="proNum"
          min-width="120"
          align="center"
          label="需同步商品数">
        </el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-button @click="oneKeySync(scope.row)" type="primary" size="small">一键同步</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="proSyncDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitOneKeySync">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="批量设置价格"
      :visible.sync="batchSetPriceDialog"
      v-if="batchSetPriceDialog"
      v-model="batchSetPriceDialog"
      :close-on-click-modal="false"
      width="75%"
    >
      <el-table
        border
        :data="batchSetPriceList"
        :header-cell-style="{background:'#F3F3F3'}"
        id="act-set-table"
      >
        <el-table-column
          prop="proName"
          min-width="120"
          align="center"
          label="商品名称">
        </el-table-column>
        <el-table-column
          prop="distributor"
          min-width="120"
          align="center"
          label="分销商">
        </el-table-column>
        <el-table-column
          prop="specName"
          min-width="120"
          align="center"
          label="规格名称">
        </el-table-column>
        <el-table-column
          prop="costPrice"
          min-width="120"
          align="center"
          label="成本价">
        </el-table-column>
        <el-table-column label="供货价" min-width="120" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.supplyPrice" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.status">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchSetPriceDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitBatchSetPrice">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetAllUser,
  CreateUser,
  GetUserDetail,
  UpdateUser,
  DeleteUser,
  GetRoles
} from "../../api/api";
import toolbar from "../../components/Toolbar";
import {getButtonList} from "../../promissionRouter";
export default {
  components: {toolbar},
  data() {
    return {
      activeName: 'second',

      buttonList_toolBar: [],
      buttonList_table: [],

      tableLoading: false,
      currentRow: [],
      total: 0,
      queryForm: {
        optionTime: null,
        operator: null,
        startDate: null,
        endDate: null,
        pageIndex: 1,
        pageSize: 10
      },
      userList: [
        {
          sort: 1,
          spuId: 11,
          skuId: 22,
          productPic: 'picUrl',
          productName: '商品1',
          productBrand: '美的',
          productType: '自有',
          productSpec: '规格',
          distributor: '美的',
          costPrice: 1111,
          supplyPrice: 3333,
          productStatus: 1,
          syncStatus: '2',
          optionTime: '2022-02-21 10:51'
        },
        {
          sort: 1,
          spuId: 22,
          skuId: 33,
          productPic: 'picUrl',
          productName: '商品2',
          productBrand: '海尔',
          productType: '自有',
          productSpec: '规格',
          distributor: '海尔',
          costPrice: 33,
          supplyPrice: 444,
          productStatus: 2,
          syncStatus: '1',
          optionTime: '2022-02-21 10:52'
        },
      ],
      submitLoading: false,

      addProductDialog: false,
      addProductForm: {
        SpuId: null,
        ProName: null,
        ProCode: null,
        ProTypeId: null,
        ProBrandId: null,
        pageIndex: 1,
        pageSize: 10
      },
      addProductList: [
        {
          SpuId: 11,
          ProName: 'pro1',
          ProTypeName: '自有',
          ProBrandName: '美的',
          ProCode: 222,
          CostPrice: 11111
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        }
      ],

      setPriceDialog: false,
      setPriceList: [
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
      ],

      proSyncDialog: false,
      syncList: [
        {
          distributor: 'cc',
          proNum: 'cc'
        },
        {
          distributor: 'cc',
          proNum: 'cc'
        },
      ],

      batchSetPriceDialog: false,
      batchSetPriceList: [
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
      ],
    };
  },
  mounted() {
    this.renderButton();
  },
  methods: {
    handleClick() {
      if (this.activeName == "first") {
        this.$router.push(`/Sale/Product`);
      }
      if (this.activeName == "second") {
        this.$router.push(`/Sale/OptionInto`);
      } 
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    addProduct() {
      this.addProductDialog = true;
    },
    renderButton() {
      let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
      var buttonList = getButtonList(this.$route.path, routers);
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow == 10 && item.isVisible;
      });
      this.buttonList_table = this.$utils.sortDataArrayAsc(buttonList.filter((item) => {
        return item.buttonShow == 20 && item.isVisible;
      }), 'order');
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    getUserList() {
      this.tableLoading = true;
      let params = {
        Keyword: this.queryForm.Keyword,
        IsActive: this.queryForm.IsActive,
        SkipCount: (this.queryForm.pageIndex - 1) * 10,
        MaxResultCount: this.queryForm.pageSize
      }
      let that = this;
      GetAllUser(params).then((res) => {
        that.tableLoading = false;
        that.total = res.data.result.totalCount;
        that.userList = res.data.result.items;
      });
    },
    handleSelectionChange(val) {
      this.currentRow = val;
    },
    handleCurrentChange(val) {
      this.queryForm.pageIndex = val;
      this.getUserList();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getUserList();
    },
    search() {
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getUserList();
    },
    empty() {
      this.queryForm.Keyword = null;
      this.queryForm.IsActive = null;
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getUserList();
    },
    addUser() {
      this.userFormVisible = true;
      this.isEdit = false;
      this.userForm = {
        userName: null,
        name: null,
        surname: null,
        password: null,
        emailAddress: null,
        isActive: true,
        roleNames: []
      }
    },
    editUser() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要编辑的一行数据！');
      }
      let params = { Id: row.id };
      let that = this;
      GetUserDetail(params).then((res) => {
        if (res.data.success) {
          that.userForm = res.data.result;
          that.isEdit = true;
          that.userFormVisible = true;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    delUser() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要删除的一行数据！');
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.tableLoading = true;
        let params = { Id: row.id };
        let that = this;
        DeleteUser(params).then((res) => {
          that.tableLoading = false;
          if (res.data.success) {
            that.$message.success('删除成功');
            that.getUserList();
          } else {
            that.$message.error(res.data.msg);
          }
        });
      }).catch(() => {});
    },
    submitUser() {
      let that = this;
      that.$refs.userForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            that.submitLoading = true;
            if (!that.isEdit) {
              // surname必填且不能为空、不能为空字符串。。。
              that.userForm.surname = that.userForm.name;
              CreateUser(that.userForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('新增成功');
                  that.userFormVisible = false;
                  that.getUserList();
                } else {
                  that.$message.error(res.data.msg);
                }
              });
            } else {
              UpdateUser(that.userForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('修改成功');
                  that.userFormVisible = false;
                  that.getUserList();
                } else {
                  that.$message.error(res.data.error.message)
                }
              });
            }
          }).catch(() => {});
        }
      });
    },
    getRolesList() {
      let that = this;
      GetRoles().then((res) => {
        that.roleList = res.data.result.items;
      });
    },
    setRoles() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择一行数据！');
      }
      let params = { Id: row.id };
      let that = this;
      GetUserDetail(params).then((res) => {
        if (res.data.success) {
          that.userForm = res.data.result;
          that.setPriceDialog = true;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    submitAddPro() {
      this.setPriceDialog = true;
      // this.$confirm("确认提交吗？", "提示", {
      //   closeOnClickModal: false,
      // }).then(() => {
      //   this.submitLoading = true;
      //   let that = this;
      //   UpdateUser(that.userForm).then((res) => {
      //     that.submitLoading = false;
      //     if (res.data.success) {
      //       that.$message.success('提交成功');
      //       that.setPriceDialog = false;
      //     } else {
      //       that.$message.error(res.data.error.message)
      //     }
      //   });
      // }).catch(() => {});
    },
    submitSetPrice() {
      let flag = true;
      try {
        this.setPriceList.forEach(x => {
          if (!x.supplyPrice && x.supplyPrice == '') {
            flag = false;
            this.$message.error('请输入供货价！');
            throw Error();
          }
          if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.supplyPrice)) {
            flag = false;
            this.$message.error('供货价必须为数字（可保留两位小数）');
            throw Error();
          }
          if (!x.status) {
            flag = false;
            this.$message.error('请选择上下架！');
            throw Error();
          }
        });
      } catch (e) {
      }
      if (flag) {
        this.$confirm("本次操作是否同步相应的分销商？", "提示", {
          closeOnClickModal: false,
        }).then(() => {
          // 调用接口，并同步
          this.setPriceDialog = false;
          this.addProductDialog = false;
        }).catch(() => {
          // 调用接口，不同步
          this.setPriceDialog = false;
          this.addProductDialog = false;
        });
      }
    },
    productSync() {
      this.proSyncDialog = true;
    },
    submitOneKeySync() {

    },
    batchSetPrice() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
      this.batchSetPriceDialog = true;
    },
    submitBatchSetPrice() {
      let flag = true;
      try {
        this.batchSetPriceList.forEach(x => {
          if (!x.supplyPrice && x.supplyPrice == '') {
            flag = false;
            this.$message.error('请输入供货价');
            throw Error();
          }
          if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.supplyPrice)) {
            flag = false;
            this.$message.error('供货价必须为数字（可保留两位小数）');
            throw Error();
          }
        });
      } catch (e) {
      }
      if (flag) {
        this.$confirm("本次操作是否同步相应的分销商？", "提示", {
          closeOnClickModal: false,
        }).then(() => {
          // 调用接口，并同步
          this.batchSetPriceDialog = false;
        }).catch(() => {
          // 调用接口，不同步
          this.batchSetPriceDialog = false;
        });
      }
    },
    batchOffShelf() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
    },
    batchShelves() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
    },
    batchImport() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
    },
    offTheShelf(params) {
      let row = params.funcParams;
    },
    productSync_tab(params) {
      let row = params.funcParams;
      if (!row.supplyPrice || row.supplyPrice == '') {
        var elements = document.querySelectorAll('#user-table .el-table__body-wrapper')[0];
        let scrollWidth = elements.scrollWidth;
        elements.scrollLeft  = scrollWidth;
        return this.$message.error('请输入供货价格！');
      }
    },
    detail(params) {
      let row = params.funcParams;
    }
  }
};
</script>
<style scoped>
#main-box
{
  width: 100%;
  height:100%;
}
#content-box
{
  padding: 0 20px 20px 20px;
  width: 100%;
  height: 100%;
}
#main-box /deep/ .el-pagination {
  padding: 10px 5px;
}


.tool_box {
  padding-top: 20px;
  overflow: hidden;
}

.flex{
  display:flex
}
.flex-center{
  align-items: center;
}
.data-detail-wrap{
  padding:30px;
}
.data-detail-wrap .dataBox{
  margin-top:40px;
}
.elSelect{
  width:200px;
}
.el-dialog{
  padding-bottom:0;
}
.img_box {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  position: relative;
  margin-right: 10px;
  display:inline-block;
}
.img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}
.del_box {
  position: absolute;
  top: -15px;
  right: -10px;
  width: 20px;
  height: 20px;
  cursor:pointer;
}
.play_btn{
  position: absolute;
  top: 50%;
  left:50%;
  transform:translate3d(-50%,-50%,0);
  z-index: 2;
}
.play_btn i{
  font-size: 25px;
  color: #666;
  border: 1px solid #666;
  border-radius: 50%;
  cursor:pointer;
}
.del_box img {
  height: 100%;
  width: 100%;
}
.avatar-uploader{
  display: inline-block;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.video-uploader{
  display:inline-block;
}
.video-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.videoWrap{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  background: rgba(0,0,0,.6);
}
.videoWrapInner{
  background:white;
  width:600px;
  height:400px;
}
.picPreview{
  display:flex;
  margin-bottom:15px;
}
.picPreview div{
  width:120px;
  height:120px;
  overflow:hidden;
  margin-right:10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position:relative;
}
.del {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  cursor:pointer;
}

.del img {
  height: 100%;
  width: 100%;
}
</style>
